import { render, staticRenderFns } from "./TsgManagement.vue?vue&type=template&id=016ebebb&scoped=true&"
import script from "./TsgManagement.vue?vue&type=script&lang=js&"
export * from "./TsgManagement.vue?vue&type=script&lang=js&"
import style0 from "./TsgManagement.vue?vue&type=style&index=0&id=016ebebb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ebebb",
  null
  
)

export default component.exports